/**
 * SLL API Interceptor Module — Fallback/Complement
 * 
 * The PRIMARY interceptor is the inline <script> in public/index.html
 * (runs BEFORE emergent-main.js). This module serves as a safety net.
 * 
 * Extra defense: obtains a CLEAN XMLHttpRequest from a hidden iframe,
 * which platform scripts cannot wrap (they only modify the main window).
 */

// Check if the inline interceptor already installed
if (window.__sllFetch) {
  // Already installed — nothing to do
} else {
  // Try to get a CLEAN XHR from a hidden iframe (platform scripts only wrap main window)
  var RealXHR;
  try {
    var f = document.createElement('iframe');
    f.style.display = 'none';
    f.src = 'about:blank';
    (document.body || document.documentElement).appendChild(f);
    RealXHR = f.contentWindow.XMLHttpRequest;
    f.parentNode.removeChild(f);
  } catch(e) {
    RealXHR = window.__realXHR || window.XMLHttpRequest;
  }

  function getToken() {
    try { return sessionStorage.getItem('session_token') || localStorage.getItem('sll_session_token') || ''; }
    catch(e) { return ''; }
  }

  function xhrFetch(url, opts) {
    return new Promise(function(resolve, reject) {
      var m = (opts && opts.method) || 'GET';
      var xhr = new RealXHR();
      xhr.open(m.toUpperCase(), url, true);
      xhr.withCredentials = true;
      // Prevent browser from serving cached API responses
      try { xhr.setRequestHeader('Cache-Control', 'no-cache, no-store'); } catch(e) {}
      try { xhr.setRequestHeader('Pragma', 'no-cache'); } catch(e) {}
      var hasCT = false, hasAuth = false;
      if (opts && opts.headers) {
        var h = opts.headers;
        if (typeof h.forEach === 'function') {
          h.forEach(function(v, k) {
            try { xhr.setRequestHeader(k, v); } catch(e) {}
            if (k.toLowerCase() === 'content-type') hasCT = true;
            if (k.toLowerCase() === 'authorization') hasAuth = true;
          });
        } else if (typeof h === 'object') {
          Object.keys(h).forEach(function(k) {
            try { xhr.setRequestHeader(k, h[k]); } catch(e) {}
            if (k.toLowerCase() === 'content-type') hasCT = true;
            if (k.toLowerCase() === 'authorization') hasAuth = true;
          });
        }
      }
      if (!hasAuth) {
        var tk = getToken();
        if (tk) { try { xhr.setRequestHeader('Authorization', 'Bearer ' + tk); } catch(e) {} }
      }
      var body = opts && opts.body;
      if (body && typeof body === 'string' && !hasCT) {
        try { xhr.setRequestHeader('Content-Type', 'application/json'); } catch(e) {}
      }
      xhr.onload = function() {
        var rh = {}, raw = (xhr.getAllResponseHeaders() || '').trim();
        if (raw) {
          raw.split('\r\n').forEach(function(l) {
            var i = l.indexOf(': ');
            if (i > 0) rh[l.substring(0, i).toLowerCase()] = l.substring(i + 2);
          });
        }
        var rt = xhr.responseText;
        resolve({
          ok: xhr.status >= 200 && xhr.status < 300,
          status: xhr.status, statusText: xhr.statusText, url: url,
          headers: {
            get: function(n) { return rh[n.toLowerCase()] || null; },
            has: function(n) { return n.toLowerCase() in rh; },
            forEach: function(cb) { Object.keys(rh).forEach(function(k) { cb(rh[k], k); }); }
          },
          json: function() { try { return Promise.resolve(JSON.parse(rt)); } catch(e) { return Promise.reject(e); } },
          text: function() { return Promise.resolve(rt); },
          blob: function() { return Promise.resolve(new Blob([rt])); },
          arrayBuffer: function() { return Promise.resolve(new TextEncoder().encode(rt).buffer); },
          clone: function() { return this; }, redirected: false, type: 'basic'
        });
      };
      xhr.onerror = function() { reject(new TypeError('Network request failed')); };
      xhr.ontimeout = function() { reject(new TypeError('Request timed out')); };
      xhr.send(body != null ? body : null);
    });
  }

  var origFetch = window.fetch ? window.fetch.bind(window) : null;

  function sllFetch(input, init) {
    if (!init) init = {};
    var url = input;
    if (typeof url === 'string') {
      var match = url.match(/^https?:\/\/[^/]+(\/api\/.*)$/);
      if (match) url = match[1];
    } else if (url && url.url) {
      var match2 = url.url.match(/^https?:\/\/[^/]+(\/api\/.*)$/);
      if (match2) url = match2[1];
    }
    if (typeof url === 'string' && url.indexOf('/api/') === 0) {
      init.credentials = 'include';
      return xhrFetch(url, init);
    }
    if (origFetch) return origFetch(input, init);
    return xhrFetch(typeof input === 'string' ? input : '/', init);
  }

  try {
    Object.defineProperty(window, 'fetch', {
      get: function() { return sllFetch; },
      set: function() {},
      configurable: false,
      enumerable: true
    });
  } catch(e) {
    window.fetch = sllFetch;
  }

  window.__sllFetch = sllFetch;
  window.__realXHR = RealXHR;
}
